const hostOf = (value?: string): string => {
    try {
        return new URL(value ?? '').hostname.toLowerCase();
    } catch {
        return '';
    }
};

// Our own domains, taken from settings the bundle already has for each environment:
// the payment API host and the domain of the country sites ("https://XX.opensooq.com/LANG/").
const trustedHosts = (): string[] => [
    hostOf(process.env.REACT_APP_PAYMENT_API_URL),
    hostOf((process.env.REACT_APP_BACK_BUTTON_REDIRECT ?? '').replace('XX.', '')),
].filter(Boolean);

/**
 * Returns the address when it is safe to send the customer there, otherwise null.
 * Safe means: the same origin as this page, or https on one of our own hosts
 * (or a subdomain of them). javascript:, data:, http: and anything else is refused.
 */
export const toSafeRedirect = (value: string | null): string | null => {
    if (!value) return null;

    let url: URL;
    try {
        url = new URL(value, window.location.origin); // a relative path resolves to this origin
    } catch {
        return null;
    }

    if (url.username || url.password) return null;
    if (url.origin === window.location.origin) return url.toString();
    if (url.protocol !== 'https:') return null;

    const host = url.hostname.toLowerCase();
    return trustedHosts().some(trusted => host === trusted || host.endsWith(`.${trusted}`))
        ? url.toString()
        : null;
};
